/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable, Optional } from "@angular/core";
import { PhoneNumberFormat, PhoneNumberUtil } from "google-libphonenumber";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { StringOrPhoneNumber } from "../models/common.model";

export class JsonParser {
  parse(text: string): any {
    return JSON.parse(text);
  }
}

const util = new PhoneNumberUtil();


export class PhoneCustomJsonParser implements JsonParser {
  parse(text: string): any {
    return JSON.parse(text, customReviver);
  }
}

const customReviver = (key: string, value: any) => {
  if (key && key.toLocaleLowerCase().endsWith('phone') && typeof value === 'string') {
    try {
      const parsed = util.parse(value);
      const cc = parsed.getCountryCodeOrDefault();
      const rv: StringOrPhoneNumber = {
        countryCode: util.getRegionCodeForNumber(parsed) ?? 'us',
        e164Number: util.format(parsed, PhoneNumberFormat.E164),
        number: (cc === 1) ? util.format(parsed, PhoneNumberFormat.NATIONAL) : util.format(parsed, PhoneNumberFormat.INTERNATIONAL),
      };
      return rv;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    catch (e) {
      return value;
    }
  }
  else {
    return value;
  }
};

@Injectable()
export class JsonHttpInterceptor implements HttpInterceptor {
  constructor(@Optional() private jsonParser: JsonParser) { }

  intercept(
    httpRequest: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return httpRequest.responseType === "json"
      ? this.handleJsonResponses(httpRequest, next)
      : next.handle(httpRequest);
  }

  private handleJsonResponses(
    httpRequest: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next
      .handle(httpRequest.clone({ responseType: "text" }))
      .pipe(map(event => this.parseResponse(event)));
  }

  private parseResponse(event: HttpEvent<any>): HttpEvent<any> {
    return event instanceof HttpResponse
      ? event.clone({ body: this.jsonParser.parse(event.body) })
      : event;
  }
}
